export default __webpack_public_path__ + "static/media/angry.f367450a.gif";